import StatusConnected from './StatusConnected'
export default StatusConnected
